module.exports = __webpack_public_path__ + "img/skyscrapers-4168483_1920.26ccc2e7.jpg";